export const SERVICE_IDENTIY = 'identity';
export const SERVICE_PAYMENT = 'payment';
export const SERVICE_SUBSCRIPTION = 'subscription';
export const SERVICE_CONTENT = 'content';
export const SERVICE_MESSAGING = 'messaging';
export const SERVICE_DIRECT_MESSAGE = 'direct-message';
